(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sissilux-gift-menu"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sissilux-gift-panel'))customElements.define('sissilux-gift-panel',class extends HTMLElement{
  connectedCallback(){
    if(this.events)return;this.events=new AbortController();const options={signal:this.events.signal},host=this.closest('header-menu'),details=this.closest('details'),summary=details.querySelector('summary');
    details.addEventListener('toggle',()=>{summary.setAttribute('aria-expanded',String(details.open));if(details.open){this.style.setProperty('--sx-menu-height',Math.max(160,innerHeight-this.getBoundingClientRect().top-18)+'px');host.closest('nav').querySelectorAll('header-menu').forEach(other=>{if(other!==host)other.close();});}},options);
    document.addEventListener('pointerdown',event=>{if(details.open&&!host.contains(event.target))host.close();},options);
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&details.open){host.close();summary.focus();}},options);
  }
  disconnectedCallback(){this.events?.abort();this.events=null;}
});
if(!customElements.get('sissilux-gift-picker'))customElements.define('sissilux-gift-picker',class extends HTMLElement{
  connectedCallback(){
    if(this.bound)return;this.bound=true;
    this.addEventListener('change',()=>this.sync());
    // Keep focus inside the menu even on browsers that do not focus label controls.
    this.addEventListener('pointerdown',event=>{if(event.target.closest('.sx-gift__options label'))event.preventDefault();},true);
    this.addEventListener('click',event=>{
      const label=event.target.closest('.sx-gift__options label');if(!label)return;
      event.preventDefault();event.stopImmediatePropagation();
      const input=label.control;if(!input||input.disabled||this.pending)return;
      input.checked=true;input.focus({preventScroll:true});input.dispatchEvent(new Event('change',{bubbles:true}));
    },true);
    this.addEventListener('click',event=>{if(event.target.closest('[data-gift-add]')){event.preventDefault();event.stopImmediatePropagation();this.add();}},true);
  }
  sync(){const option=this.querySelector('input:checked');if(!option)return;this.querySelector('[data-gift-add]').textContent='Add to cart · '+option.dataset.price;this.querySelector('[data-gift-details]').href=this.dataset.productUrl+'?variant='+option.value;}
  async add(){
    if(this.pending)return;const option=this.querySelector('input:checked');if(!option||option.disabled)return;
    const button=this.querySelector('[data-gift-add]'),status=this.querySelector('.sx-gift__status'),viewCart=this.querySelector('[data-gift-cart]');
    const cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');const sections=cart?.getSectionsToRender?.().map(s=>s.id)||[];
    this.pending=true;button.disabled=true;button.setAttribute('aria-busy','true');button.textContent='Adding…';status.textContent='';viewCart.hidden=true;let confirmed=false;
    try{
      const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:option.value,quantity:1}],sections,sections_url:location.pathname+location.search})});
      const data=await response.json();if(!response.ok||data.status){status.textContent=typeof data.description==='string'?data.description:'Unable to add this gift card. Please try again.';return;}
      confirmed=true;status.textContent='Gift card added to your cart.';
      const drawer=this.closest('header-drawer');if(drawer?.closeMenuDrawer){drawer.closeMenuDrawer(new Event('click'));await new Promise(resolve=>setTimeout(resolve,400));}
      this.closest('header-menu')?.close?.();
      cart?.setActiveElement?.(drawer?.querySelector('summary')||this.closest('header-menu')?.querySelector('summary')||button);
      if(cart?.renderContents&&sections.length&&sections.every(id=>data.sections?.[id])){cart.classList.remove('is-empty');cart.renderContents({...data,key:data.items?.[0]?.key});}else{viewCart.hidden=false;location.assign(viewCart.href);}
      if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'gift-menu',cartData:data});
    }catch{status.textContent=confirmed?'Gift card added. View your cart to continue.':'Check your cart before trying again; we could not confirm the result.';viewCart.hidden=false;}
    finally{this.pending=false;button.disabled=false;button.removeAttribute('aria-busy');this.sync();}
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sissilux-menu-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sissilux-menu')) {
    customElements.define('sissilux-menu', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const options = {signal:this.events.signal};
        this.host = this.closest('header-menu');
        this.details = this.closest('details');
        this.summary = this.details.querySelector('summary');
        this.cards = [...this.querySelectorAll('[data-sx-groups]')];
        this.buttons = [...this.querySelectorAll('[data-sx-filter]')];
        this.media = matchMedia('(min-width:990px)');
        this.buttons.forEach(button => button.addEventListener('click', () => this.filter(button.dataset.sxFilter), options));
        this.summary.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || !this.media.matches) return;
          clearTimeout(this.openTimer);
          this.openTimer = setTimeout(() => { this.details.open = true; }, 160);
        }, options);
        this.host.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
        this.host.addEventListener('pointerleave', event => {
          clearTimeout(this.openTimer);
          if(event.pointerType === 'mouse') this.closeTimer = setTimeout(() => {
            if (!this.host.contains(document.activeElement)) this.host.close();
          }, 220);
        }, options);
        this.details.addEventListener('toggle', () => {
          this.summary.setAttribute('aria-expanded', String(this.details.open));
          if (this.details.open) {
            this.resizePanel();
            this.closest('.header__inline-menu').querySelectorAll('header-menu').forEach(menu => { if (menu !== this.host) menu.close(); });
          } else { clearTimeout(this.openTimer); }
        }, options);
        document.addEventListener('pointerdown', event => {
          if (this.details.open && !this.host.contains(event.target)) this.host.close();
        }, options);
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.details.open) {
            this.host.close();
            this.summary.focus();
          }
        }, options);
        this.media.addEventListener('change', () => { if (!this.media.matches) this.host.close(); }, options);
        window.addEventListener('resize', () => { if (this.details.open) this.resizePanel(); }, options);
        this.closest('.shopify-section').addEventListener('shopify:block:select', event => {
          const button=this.buttons.find(item=>item.dataset.sxFilter===event.detail?.blockId);
          if(button){this.details.open=true;this.filter(button.dataset.sxFilter);}
        }, options);
        this.filter('all');
        this.summary.setAttribute('aria-expanded', String(this.details.open));
      }
      resizePanel() {
        this.style.setProperty('--sx-menu-height', Math.max(160, window.innerHeight - this.getBoundingClientRect().top - 18) + 'px');
      }
      filter(key) {
        let count=0;
        this.cards.forEach(card => {card.hidden = key !== 'all' && !card.dataset.sxGroups.split(/\s+/).includes(key); if(!card.hidden)count++;});
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sxFilter === key)));
        this.querySelector('[data-sx-count]').textContent=String(count);
        this.querySelector('.sx-mega__empty').hidden=count>0;
        this.querySelector('.sx-mega__layout').scrollTop=0;
      }
      disconnectedCallback() { clearTimeout(this.openTimer); clearTimeout(this.closeTimer); this.events?.abort(); this.events=null; }
    });
  }

if(!customElements.get('sissilux-mobile-filters'))customElements.define('sissilux-mobile-filters',class extends HTMLElement{
 connectedCallback(){if(this.events)return;this.events=new AbortController();this.addEventListener('click',event=>{const button=event.target.closest('[data-sx-mobile-filter]');if(!button)return;event.preventDefault();event.stopImmediatePropagation();const key=button.dataset.sxMobileFilter;this.querySelectorAll('[data-sx-mobile-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));this.querySelectorAll('[data-sx-mobile-groups]').forEach(card=>card.hidden=key!=='all'&&!card.dataset.sxMobileGroups.split(/\s+/).includes(key));},{capture:true,signal:this.events.signal});}
 disconnectedCallback(){this.events?.abort();this.events=null;}
});

if(!customElements.get('sissilux-menu-label'))customElements.define('sissilux-menu-label',class extends HTMLElement{
 connectedCallback(){this.owner=this.closest('.shopify-section');this.refresh=()=>this.applyLabels();this.frame=requestAnimationFrame(this.refresh);document.addEventListener('DOMContentLoaded',this.refresh,{once:true});}
 applyLabels(){if(!this.owner)return;const rules=[...this.owner.querySelectorAll('sissilux-menu-label')].map(el=>{try{return JSON.parse(el.querySelector('script').textContent)}catch{return null}}).filter(r=>r?.enabled&&r.title);this.owner.querySelectorAll('[data-sx-product]').forEach(card=>{const rule=rules.find(r=>(r.products||[]).some(id=>String(id)===card.dataset.sxProduct));let badge=card.querySelector('.sx-nav-card__badge');if(!rule){badge?.remove();return;}if(!badge){badge=document.createElement('span');badge.className='sx-nav-card__badge';card.prepend(badge);}badge.textContent=rule.title;badge.style.background=rule.title.trim().toUpperCase()==='HOT'?'rgb(var(--color-base-accent-1))':rule.background;badge.style.color=rule.color;});}
 disconnectedCallback(){cancelAnimationFrame(this.frame);document.removeEventListener('DOMContentLoaded',this.refresh);if(this.owner?.isConnected)requestAnimationFrame(()=>this.applyLabels());}
});
if(!customElements.get('sx-menu-support'))customElements.define('sx-menu-support',class extends HTMLElement{
  connectedCallback(){
    if(this.events)return;
    this.events=new AbortController();
    // Keep the shared close control in the active submenu keyboard cycle.
    this.closest('header-drawer')?.addEventListener('keydown',event=>{
      if(event.key!=='Tab'||!matchMedia('(max-width:989px)').matches)return;
      const drawer=this.closest('header-drawer');
      const panels=[...drawer.querySelectorAll('.sx-series-menu .menu-drawer__submenu')].filter(el=>getComputedStyle(el).visibility==='visible');
      const panel=panels.at(-1);if(!panel)return;
      const headerControls=[...drawer.querySelectorAll('#HeaderDrawer_Header a[href],#HeaderDrawer_Header button')];
      const controls=[...headerControls,...panel.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"]')].filter(el=>el&&!el.disabled&&el.tabIndex>=0&&el.getClientRects().length&&getComputedStyle(el).visibility==='visible');
      if(!controls.length)return;
      const index=controls.indexOf(document.activeElement);
      event.preventDefault();event.stopImmediatePropagation();
      controls[(index+(event.shiftKey?-1:1)+controls.length)%controls.length].focus();
    },{capture:true,signal:this.events.signal});
    this.addEventListener('click',event=>{
      const button=event.target.closest('.sx-series-support-toggle');
      if(!button||!this.contains(button))return;
      event.preventDefault();event.stopImmediatePropagation();
      const expanded=button.getAttribute('aria-expanded')==='true';
      button.setAttribute('aria-expanded',String(!expanded));
      this.querySelector('ul').hidden=expanded;
    },{capture:true,signal:this.events.signal});
  }
  disconnectedCallback(){this.events?.abort();this.events=null;}
});
  } catch(e) { console.error(e); }
})();

})();
